import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 29.8.",
  "description": "",
  "published": "2011-08-29T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-29-8-2/swizec/2303"],
  "categories": "Apple, Learning, Personal, Wi-Fi, Wi-Fi Protected Access, Wireless",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/300px-WiFi-detector1.jpg",
        "alt": "A Wi-Fi detector",
        "title": "A Wi-Fi detector"
      }}></img></p>
    <p>{`Today I learned that updating my laptop to `}<a parentName="p" {...{
        "href": "http://www.apple.com/macosx/",
        "title": "Mac OS X"
      }}>{`Mac OSX`}</a>{` Lion caused a very strange issue with my home wireless network. Actually I learned the issue was tehre as soon as I got back home, but didn't really have time to look into it ... apparently it no longer supports WPA encryption and my router doesn't support anything stronger than WPA. Sad, I know, but that's what it is.`}</p>
    <p>{`The only symptom of this is an error report along the liens of "There is a timeout" and instantly dropping the connection. When I turn off encryption the damn thing connects happily as ever. Now granted WPA isn't very strong, but it's still stronger than nothing ... the only sense I can see here is that `}<a parentName="p" {...{
        "href": "http://www.apple.com",
        "title": "Apple"
      }}>{`Apple`}</a>{` wants to protect me from a false sense of security?`}</p>
    <p>{`Guess I'm getting a new `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Wi-Fi",
        "title": "Wi-Fi"
      }}>{`wi-fi router`}</a>{` soon. Any recommendations?`}</p>
    <p>{`Another thing I learned is that it is much cheaper to buy `}<em parentName="p">{`twelve`}</em>{` fluffy things for a whiteboard eraser than a new eraser. You can only buy twelve at a time otherwise I would have bought one since this one has lasted me what ... two, three years? Well ever since I got a whiteboard at home anyway. So I think I'm good until the end of time with this batch.`}</p>
    <p>{`Of course I'll lose them first and have to buy a new pack every time I want to replace. Good business model that, sell twelve times as much as the customer needs, produce endless amounts of waste.`}</p>
    <p>{`Oh and `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-learned-two-things-today-21-8/swizec/2275",
        "title": "I learned two things today 21.8."
      }}>{`everyone got their postcards`}</a>{` today. Yay!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.brighthub.com/computing/hardware/articles/119956.aspx"
        }}>{`A Comparison of Common Wireless Network Protocols`}</a>{` (brighthub.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techattitude.com/computers-and-internet/how-to-secure-your-wireless-network/"
        }}>{`How to Secure Your Wireless Network`}</a>{` (techattitude.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ask.metafilter.com/194421/Connect-Damn-You"
        }}>{`Connect Damn You`}</a>{` (ask.metafilter.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blogs.cisco.com/smallbusiness/5-steps-to-fortify-your-wireless-network/"
        }}>{`5 Steps to Fortify Your Wireless Network`}</a>{` (blogs.cisco.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7bcaae5f-a8f7-4723-97c6-60af8a11c3d8",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      